export default __webpack_public_path__ + "static/media/carousel3.867d51f6.png";